// extracted by mini-css-extract-plugin
export default {"form":"ConnectShopifyForm_form__+tNK+","body":"ConnectShopifyForm_body__EUFS5","footer":"ConnectShopifyForm_footer__m6deG","button":"ConnectShopifyForm_button__gI5o3"};